import React, { useEffect, useRef, useState } from 'react'
import './Madh.css'
import axios from 'axios';
import notes from "../../imgs/notes.png";
import options from "../../imgs/options.png";
import profile from "../../imgs/profile.png";
import upload from "../../imgs/upload.png";
import Viewprofile from '../Viewprofile/Viewprofile';
import { ToastContainer, toast } from 'react-toastify';

const Madh = () => {

    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [sender, setsender] = useState(false);
    const [requester, setrequester] = useState(false);
    const [madhsr, setmadhsr] = useState();
    const [loading3, setLoading3] = useState(false);
    const [input, setInput] = useState({ search: "", notes: "",recfile: "" });
    const [DataSource, setDataSource] = useState([]);
    const refoptions = useRef(null);
    const refoptionsclose = useRef(null);
    const [contactdata, setContactdata] = useState({ mobno: "****************", amobno: "********************************", address: "********************************" });
    const refprofile = useRef(null);
    const refprofileclose = useRef(null);
    const fileInputRef = useRef(null);
    const [showconfirm, setShowconfirm] = useState(false);
    const [showfeed, setShowfeed] = useState(false);
    const [DataSourcepr, setDataSourcepr] = useState([]);
    const [path, setPath] = useState("photo");
    const [exist, setExist] = useState("");
    const [sr, setSr] = useState();
    const [viewnote, setViewnote] = useState(false);
    const [currentnote, setcurrentnote] = useState(false);
    const notify = (msg) => toast(msg);

    const handlespanclick = (event) => {
          fileInputRef.current.click();
      };

      const handleImageUpload = (event, inputname) => {
        const fileimg = event.target.files[0].name;
        const file = event.target.files[0];
    
        if (inputname === "recfile") {
          setInput((prevState) => ({
            ...prevState,
            recfile: file,
          }));
        }
      };

      useEffect(()=>{
        console.log(input);
      },[input])

    const handlephoto = () => {
        if (path === "photo") {
            setPath("photo2")
        }
        else if (path === "photo2") {
            setPath("photo3")
        }
        else if (path === "photo3") {
            setPath("photo")
        }
    }

    const sendtomadhysti = () => {

    }

    const handleviewnote = () => {
        setViewnote(!viewnote);
    }

    const confirmcontact = () => {


    }

    const uploadnote = () => {

        let rawData = {
            sr: madhsr,
            notes: input.notes,
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)

        axios.post('https://softtesting.in/php/cust/uploadnotesweb.php', formData, {
            'Content-Type': 'multipart/form-data',

        }).then(function sample(response) {
            if (response.data) {
                notify(response.data);
                setInput({ notes: "" });
                setViewnote(false)

            }
        }).catch(err => {
            console.log(err);
        });
    }

    const showcontacts = () => {
        {
            DataSourcepr.map((user, index) => (
                setContactdata({ mobno: user.mobno, amobno: user.amobno, address: user.address })
            ))
        }

    }


    useEffect(() => {
        getprofiles("all");
    }, [])

    const openoptions = (sendid, reqid, madhsr,note) => {
        setsender(sendid);
        setrequester(reqid);
        setmadhsr(madhsr);
        setcurrentnote(note);
        refoptions.current.click();
    }

    const closefeed = () => {
        setShowfeed(false);
    }

    const handleChange = (event) => {
        const name = event.target.name;
        const valuecurrent = event.target.value;

        setInput(value => ({ ...value, [name]: valuecurrent }))
    }

    const getprofiles = (fl) => {

        if (fl === "all") {
            setLoading(true);
        }
        else if (fl === "pending") {
            setLoading2(true);
        }
        else if (fl === "completed") {
            setLoading3(true);
        }
        let rawData = {
            branchcode: localStorage.getItem("brno"),
            flag: fl,
            search: input.search,

        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)

        axios.post('https://softtesting.in/php/cust/getmadhyasthiweb.php', formData, {
            'Content-Type': 'multipart/form-data',

        }).then(function sample(response) {
            console.log(response.data);
            setInput({ search: "" });
            setDataSource(response.data);

        }).catch(err => {
            console.log(err);
        })
            .finally(() => {
                setLoading(false);
                setLoading2(false);
            });
    }

    const opensenderprofile = (srr) => {
        setSr(srr);
        refprofile.current.click();
        getaccountdata(srr);
        // showcontacts();
    }

    const getaccountdata = (srrr) => {
        let rawData = {
            sr: srrr,
            rootsr: sender,
            veri: "-",
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)

        axios.post('https://softtesting.in/php/cust/getaccountdataweb.php', formData, {
            'Content-Type': 'multipart/form-data',

        }).then(function sample(response) {

            setDataSourcepr(response.data);

        }).catch(err => {
            console.log(err);
        });
    }

    const clearcontact = () => {
        refprofileclose.current.click();
        setContactdata({ mobno: "****************", amobno: "********************************", address: "********************************" });
        setShowconfirm(false);
        closefeed();
    }

    return (
        <>
            <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                hidden="{true}"
                ref={refprofile}
                data-bs-target="#exampleModaldelete"
            >
            </button>

            <div className="modal fade" id="exampleModaldelete" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: '80vw' }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel"></h5>

                            <button type="button" className="btn-close" onClick={clearcontact} data-bs-dismiss="modal" ref={refprofileclose} aria-label="Close">
                            </button>
                        </div>
                        <div className="modal-body">
                            <Viewprofile DataSource={DataSource} DataSourcepr={DataSourcepr} handlephoto={handlephoto} path={path} contactdata={contactdata} showconfirm={showconfirm} showcontacts={showcontacts} exist={exist} sendtomadhysti={sendtomadhysti} confirmcontact={confirmcontact} user={"madh"} showfeed={showfeed} setShowfeed={setShowfeed} />
                        </div>
                    </div>
                </div>
            </div>


            <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                hidden="{true}"
                ref={refoptions}
                data-bs-target="#exampleModaloptions"
            >
            </button>

            <div className="modal fade" id="exampleModaloptions" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: '40vw' }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Choose Option</h5>

                            <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refoptionsclose} aria-label="Close">
                            </button>
                        </div>
                        <div className="modal-body">
                            <div onClick={() => opensenderprofile(sender)} className="rowmadh">
                                <img className='optimg2' src={profile} alt="" />
                                <span className="regularboldmadh">View Sender Profile</span>
                            </div>
                            <div className="linemadh"></div>
                            <div onClick={() => opensenderprofile(requester)} className="rowmadh">
                                <img className='optimg2' src={profile} alt="" />
                                <span className="regularboldmadh">View Requested Profile</span>
                            </div>
                            <div className="linemadh"></div>
                            <div className="rowmadh">
                                <img className='optimg2' src={upload} alt="" />
                                <span onClick={handleviewnote} className="regularboldmadh">Uplod Notes</span>
                                {
                                    viewnote ?
                                        <div className="note">
                                            <input autoComplete='off' className="form-control feedinput" id="notes" name="notes" value={input.notes} onChange={handleChange} placeholder='Enter Note'></input>
                                            <div onClick={() => uploadnote(madhsr)} className="buttonfeed">
                                                <span className="regularboldregi">Upload</span>

                                            </div>
                                        </div>
                                        : ""
                                }
                            </div>
                            <div className="linemadh"></div>
                            <div className="rowmadh">
                                <img className='optimg2' src={upload} alt="" />
                                <span className="regularboldmadh" onClick={handlespanclick}>Uplod Recording File</span>
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={(event) => handleImageUpload(event, "recfile")}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='madhmain'>
                <div className="madhmainback">

                    <div className="options">
                        <span className='regularboldfeed'>Branch Number- {localStorage.getItem("brno")}</span>
                        <div onClick={() => getprofiles("all")} style={{ marginLeft: "10px" }} className="obuttonactive">{loading ? "Please Wait.." : "All Profiles"}</div>
                        <div onClick={() => getprofiles("pending")} className="obuttonactive">{loading2 ? "Please Wait.." : "Pending Profiles"}</div>
                        <div onClick={() => getprofiles("completed")} className="obuttonactive">Completed Profiles</div>

                        <div className="rowfeed">
                            <div className="rowfeed2">
                                <img className='smalllogo' src={notes} alt="" />
                                <input autoComplete='off' className="form-control feedinput" id="search" name="search" value={input.search} onChange={handleChange} placeholder='Search Profile'></input>

                                <div onClick={() => getprofiles("all")} className="buttonfeed">
                                    <span className="regularboldregi">Search</span>
                                </div>
                                <div className="buttonfeed">
                                    <span className="regularboldregi">Export</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="midmadh">
                        <table id="table-to-xls" className="table table-striped">
                            <thead>
                                <tr>
                                    <th className='color' scope="col">Sr</th>
                                    <th className='color' scope="col">Requested From</th>
                                    <th className='color' scope="col">Requested For</th>
                                    <th className='color' scope="col">Status</th>
                                    <th className='color' scope="col">Options</th>

                                </tr>
                            </thead>
                            <tbody>
                                {DataSource && DataSource.length > 0 && DataSource.map((user, index) =>
                                    <tr key={index + 1}>
                                        <td className={user.status === "Completed" ? `green` : 'regularbold'}>{index + 1}</td>
                                        <td className={user.status === "Completed" ? `green` : 'regularbold'}>{user.senderid}</td>
                                        <td className={user.status === "Completed" ? `green` : 'regularbold'}>{user.viewid}</td>
                                        <td className={user.status === "Completed" ? `green` : 'regularbold'}>{user.status}</td>
                                        <td className={user.status === "Completed" ? `green` : 'regularbold'}> <img onClick={() => openoptions(user.senderid, user.viewid, user.sr,user.notes)} className='optimg' src={options} alt="" /> </td>

                                    </tr>
                                )}

                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
            <ToastContainer />
        </>
    )
}

export default Madh
